module.exports = __webpack_public_path__ + "static/media/preorder.18523c29.jpg";